import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useListProjectVariablesQuery } from "@generated";
import type { ProjectVariable } from "../../ProfessionalServices/common/types/ProjectVariable";

// Account-level user-defined-field definitions for the `resource` context, with
// empty values — used to seed the New form (the Edit form gets values from the
// resource's own `user-defined-fields`).
export const useResourceUdfDefinitions = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data, isLoading } = useListProjectVariablesQuery({
    slug: accountSlug,
    filter: { "variable-context": "resource", active: true },
  });

  const definitions: ProjectVariable[] = (data?.data ?? []).map((pv: any) => ({
    id: pv.id?.toString() ?? "",
    name: pv.attributes?.name ?? "",
    label: pv.attributes?.label ?? "",
    required: pv.attributes?.required ?? false,
    "variable-type": pv.attributes?.["variable-type"],
    variable_type: pv.attributes?.["variable_type"],
    select_options: pv.attributes?.select_options ?? [],
    "select-options": pv.attributes?.["select-options"] ?? [],
    minimum: pv.attributes?.minimum,
    maximum: pv.attributes?.maximum,
    value: "",
  }));

  return { definitions, isLoading };
};

export default useResourceUdfDefinitions;
